import React from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowAltLeft, faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons';
import colors from '@general/colors';

const EditProfileNavLink = ({ to, type, children }) => {
    const renderIcon = () => {
        const icon = type === 'prev' ? faLongArrowAltLeft : faLongArrowAltRight;
        return <FontAwesomeIcon icon={icon} color={colors.link} size="lg" className="cursor-pointer" />;
    };

    return (
        <Link to={to} style={{ fontSize: '14px', color: colors.link, textAlign: type === 'prev' ? 'left' : 'right' }}>
            {type === 'prev' && <>{renderIcon()} Previous: </>}
            {type === 'next' && 'Next: '}
            {children}
            {type === 'next' && <> {renderIcon()}</>}
        </Link>
    );
};

EditProfileNavLink.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    to: PropTypes.string,
    type: PropTypes.oneOf(['next', 'prev']),
};

export default EditProfileNavLink;
